const UIkit = window.UIkit;

if (window.sfEnv && window.sfEnv.isDesignMode) {
  import('./backend-tweaks').then(() => {
    console.log('Loaded backend tweaks')
  });
}

const $ = (css, parent = document) => parent.querySelector(css);
const $$ = (css, parent = document) => parent.querySelectorAll(css);

let headerNav = document.querySelector('header');
let root = $(':root');
const resizeObserver = new ResizeObserver(entries => {
  for (let entry of entries) {
    if (entry.target === headerNav) {
      let box = headerNav.getBoundingClientRect();
      root.style.setProperty('--offcanvas-top', `${box.height}px`);
    }
  }
});
resizeObserver.observe(headerNav);

let closeActiveOffcanvas = $('.close-active-offcanvas');
let mobileNavOffcanvasToggle = $('.mobile-nav-offcanvas-toggle');

let activeOffcanvas = null;

$$('[uk-offcanvas]').forEach(offcanvas => {
  let toggles = [];

  setTimeout(() => {
    headerNav.querySelectorAll('[uk-toggle]').forEach(toggle => {
      if (toggle.__uikit__ && toggle.__uikit__['toggle']) {
        if (toggle.__uikit__['toggle'].target[0] === offcanvas) {
          toggles.push(toggle);
        }
      }
    });
  }, 0);

  //	Fires after an item is shown.
  offcanvas.addEventListener('show', function (e) {
    if(e.target.classList.contains('facet-accordion-button')) {
      return
    }
    activeOffcanvas = offcanvas;
    closeActiveOffcanvas.classList.remove('uk-hidden');

    if (
      offcanvas.id === window.sfEnv.searchOffcanvasId ||
      offcanvas.id === window.sfEnv.mobileLanguageSelectorModalWindowOffcanvasId
    ) {
      mobileNavOffcanvasToggle.classList.add('uk-visible@m');
    }

    toggles.forEach(t => {
      t.classList.add('uk-visible@m');
    });

    setTimeout(() => {
      document.body.style.height = '100vh';
      document.body.style.overflowY = 'hidden';
      document.documentElement.style.overflowY = 'hidden';
    }, 0);
  });

  //Fires after an item's hide animation has started.
  offcanvas.addEventListener('hide', function (e) {

    //Prevent menu icon to toggle if we click on Back button
    if(e.target.classList.contains('sub-nav') || e.target.classList.contains('facet-accordion-button')) {
      return;
    }
    activeOffcanvas = null;
    closeActiveOffcanvas.classList.add('uk-hidden');

    if (
      offcanvas.id === window.sfEnv.searchOffcanvasId ||
      offcanvas.id === window.sfEnv.mobileLanguageSelectorModalWindowOffcanvasId
    ) {
      mobileNavOffcanvasToggle.classList.remove('uk-visible@m');
    }

    if (offcanvas.id === window.sfEnv.mobileLanguageSelectorModalWindowOffcanvasId) {
      localStorage.setItem('region-modal-window-state', 'closed');
    }

    toggles.forEach(t => {
      t.classList.remove('uk-visible@m');
    });

    setTimeout(() => {
      document.body.style.height = 'auto';
      document.body.style.overflowY = 'auto';
      document.documentElement.style.overflowY = 'auto';
    }, 0);
  });
});

closeActiveOffcanvas && closeActiveOffcanvas.addEventListener('click', () => {
  if (!activeOffcanvas) throw new Error('No offcanvas to close');
  UIkit.offcanvas(activeOffcanvas).hide();
  $$('.mobile-sub-menu').forEach(e => {
    e.classList.remove('expanded');
  });
});

let sfRoles = {};

$$('[data-sf-role]').forEach(e => {
  sfRoles[e.dataset.sfRole] = e.value;
});

const setLanguageModalWindowState = state => {
  localStorage.setItem('region-modal-window-state', state);
};

const hideLanguageModalWindow = () => {
  setLanguageModalWindowState('closed');
  toggleLanguageModalWindow();
};

const toggleLanguageModalWindow = () => {
  const mobileModalWindow = $('.modal-window-language-selector-mobile');
  const desktopModalWindow = $('.modal-window-language-selector-desktop');
  const navigationIcons = $('#header-nav .navigation-icons');
  const languageSelectorButton = $(
    'header [uk-toggle="target:#lang-ce6687e1-6228-4243-b9c8-2e5cc510bec2"]'
  );
  const regionModalWindowStateAfterResize = localStorage.getItem(
    'region-modal-window-state'
  );
  const isLargeDesktop = window.innerWidth > 960;

  if (isLargeDesktop) {
    mobileModalWindow.style.display = 'none';
    navigationIcons.style.display = 'block';
    languageSelectorButton.style.display = 'block';

    if (regionModalWindowStateAfterResize !== 'closed') {
      // show desktop modal window and disable page scrolling
      desktopModalWindow.style.display = 'block';
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    } else {
      // hide desktop modal window and enable page scrolling
      desktopModalWindow.style.display = 'none';
      document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }
  } else {
    desktopModalWindow.style.display = 'none';

    if (regionModalWindowStateAfterResize !== 'closed') {
      // show mobile modal window and hide clickable icons in the header
      mobileModalWindow.style.display = 'block';
      navigationIcons.style.display = 'none';
      languageSelectorButton.style.display = 'none';
      document.getElementsByTagName('html')[0].style.overflow = 'hidden';
    } else {
      // hide mobile modal window and show clickable icons in the header
      mobileModalWindow.style.display = 'none';
      navigationIcons.style.display = 'block';
      languageSelectorButton.style.display = 'block';
      document.getElementsByTagName('html')[0].style.overflow = 'auto';
    }
  }
};

const manageLanguageModalWindow = () => {
  const modalWindowMobileCloseButton = $(
    '#modal-window-language-selector-mobile-close-button'
  );
  const modalWindowDesktopCloseButton = $(
    '#modal-window-language-selector-desktop-close-button'
  );
  const modalWindowDesktopOutsideSection = $(
    '#modal-window-language-selector-desktop-outside-section'
  );

  toggleLanguageModalWindow();

  $$('#mobile-langModalWindow-d59db2ae-6952-47a4-88c2-6f09ec6dafcb a').forEach(
    link => {
      link.addEventListener('click', () =>
        setLanguageModalWindowState('closed')
      );
    }
  );
  $$('#modal-window-language-selector-desktop a').forEach(link => {
    link.addEventListener('click', () => setLanguageModalWindowState('closed'));
  });

  if (modalWindowMobileCloseButton) {
    modalWindowMobileCloseButton.addEventListener(
      'click',
      hideLanguageModalWindow
    );
  }
  if (modalWindowDesktopCloseButton) {
    modalWindowDesktopCloseButton.addEventListener(
      'click',
      hideLanguageModalWindow
    );
  }
  if (modalWindowDesktopOutsideSection) {
    modalWindowDesktopOutsideSection.addEventListener(
      'click',
      hideLanguageModalWindow
    );
  }

  $$(
    '#modal-window-language-selector-desktop-and-mobile .modal-window-language-selector-redirect-button'
  ).forEach(link => {
    const region = link.pathname.split('/')[1];
    link.addEventListener('click', () => setRegionCookie(region));
  });

  $$(
    '#modal-window-language-selector-desktop-and-mobile .language-link[data-culture]'
  ).forEach(li => {
    const region = li.dataset.region;
    li.addEventListener('click', () => setRegionCookie(region));
  });

  window.addEventListener('resize', toggleLanguageModalWindow);
};

window.addEventListener('load', () => {
  const hotspots = document.querySelectorAll('.hotspot');

  if (hotspots) {
    hotspots.forEach(hotspot => {
      if (hotspot) {
        hotspot.style.display = 'block';
      }
    });
  }
});

$$('.switcher').forEach(el => {
  let container = el.closest('.uk-section');
  let itemsContainer = container.querySelector('.switcher-items');
  if (!itemsContainer) return;

  let tabs = itemsContainer.querySelectorAll('.uk-slider-container');
  let tabsIndex = 0;
  let removedTabs = 0;
  if (tabs.length > 0) {
    tabs.forEach(tab => {
      if (!tab.querySelector('.uk-card-title')) {
        let buttons = el.querySelectorAll('.uk-button');
        let currentButton = buttons[tabsIndex];
        removedTabs++;
        if (buttons.length >= tabsIndex) {
          currentButton.style.display = 'none';
          if (currentButton.classList.contains('uk-active')) {
            currentButton.classList.remove('uk-active');
          }
          if (buttons.length > tabsIndex + 1) {
            buttons[tabsIndex + 1].classList.add('uk-active');
          }
        }
      }

      tabsIndex++;
    });

    if (removedTabs == tabsIndex) {
      container.style.display = 'none';
    }
  }

  let uuid = btoa(Math.random().toString()).substr(0, 10);

  itemsContainer.setAttribute('data-uuid', uuid);

  UIkit.switcher(el, {
    toggle: el.dataset.switcherToggle,
    connect: '[data-uuid="' + uuid + '"]',
    swiping: false,
  });

  itemsContainer.classList.add('uk-switcher');
  itemsContainer.classList.remove('switcher-items-tmp');
});

$$('.scrollspy-nav').forEach((el, idx) => {
  if (window.sfEnv.isDesignMode) {
    return;
  }
  let itemsContainer = $$('.anchor-menu-items > div');
  if (!itemsContainer) {
    return;
  }

  let links = el.querySelectorAll('a');

  links.forEach((a, i) => {
    let element = itemsContainer[i];
    if (!element) return;

    let anchor = a.innerText.replaceAll(' ', '-') + '-' + (idx + 1);

    a.setAttribute('href', '#' + anchor);
    element.setAttribute('id', anchor);

    UIkit.scrollspyNav(el, { closest: 'a', scroll: false, offset: 110 });
  });
});

function replaceMagmahTouchTextNodes(node) {
  var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
  var nodes = [];

  while ((node = walker.nextNode())) {
    nodes.push(node);
  }

  nodes.forEach((textNode) => {
    var match = /(magmah)(touch|plus)/gi.exec(textNode.nodeValue);
    if (match) {
      var span = document.createElement("span");
      span.innerHTML = textNode.nodeValue.replace(/(magmah)(touch|plus)/gi, "$1<sup>$2</sup>");
      textNode.parentNode.replaceChild(span, textNode);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const regionCookie = document.cookie
    .split('; ')
    .find(c => c.includes('region'));
  let region = regionCookie && regionCookie.split('=')[1];

  if (region === 'en-GB') {
    region = 'uk';
  }

  $$('[data-noderegions]').forEach(element => {
    var hasRegion = element.dataset.noderegions.includes(region);
    if (hasRegion === false) {
      element.remove();
    }
  });

  replaceMagmahTouchTextNodes(document.body);
});

if (
  window.personalizationManager &&
  window.location.href.indexOf('Sitefinity') === -1 &&
  window.location.href.indexOf('Preview') === -1
) {
  window.personalizationManager.addPersonalizedContentLoaded(function () {
    const mobileModalWindow = $(
      '#mobile-langModalWindow-d59db2ae-6952-47a4-88c2-6f09ec6dafcb'
    );
    const desktopModalWindow = $('#modal-window-language-selector-desktop');

    if (mobileModalWindow && desktopModalWindow) {
      manageLanguageModalWindow();
    }
  });
}

$$('.language-link[data-culture]').forEach(li => {
  const region = li.dataset.region;
  li.addEventListener('click', () => setRegionCookie(region));
});

setTimeout(() => {
  $$('a[href]').forEach(function (a) {
    if (a.href.indexOf('javascript') == 0) return;

    try {
      let link = new URL(a.href);
      if (link.host != document.location.host) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (e) {
      console.error(e);
    }
  });
}, 0);

const container = document.getElementById('infographics-related-body-content');
const related = document.getElementById('content-body-infographics');

if (container !== undefined && container !== null) {
  while (related.childNodes.length > 0) {
    container.appendChild(related.childNodes[0]);
  }
} else if(related) {
  related.classList.remove('do-not-show');
}

const { getComponent, util } = UIkit;
const { getIndex, on, ready } = util;

ready(() => {
  setTimeout(() => {
    const slideshow = $('#slideshow');
    const sliderComp = getComponent($('#thumb-nav'), 'slider');

    let counters = document.querySelectorAll(".counter");

    counters.forEach(counter => {
      const currentSlidershowWrapper = counter.closest("#slideshow");

      const firstActive = currentSlidershowWrapper.querySelector(".uk-active.uk-first-column");

      if(!firstActive) return;

      counter.innerText = firstActive.getAttribute('aria-label');
    })

    on(slideshow, 'itemshow', ({ detail, target }) => {
      if(target.getAttribute('uk-slideshow-item')) {
        counters.forEach(counter => {
          const currentSlidershowWrapper = counter.closest("#slideshow");

          if(currentSlidershowWrapper.contains(target)) {
            counter.innerText = target.getAttribute('aria-label');
          } else {
            counter.innerText = '0';
          }
        })
      }

      if (detail[0].$el === slideshow) {
        sliderComp.show(getIndex(target, target.parentNode.children));
      }
    });
  }, 500);
});
